/**
 * Comparing currency codes.
 * Pure TypeScript - no React imports.
 *
 * Currency codes are ISO 4217 and case-insensitive in meaning, but not on the wire: the
 * same offering can come back with `"USD"` in its scalars and `"usd"` in a row, and the
 * responses do not agree with each other about which. Every comparison in this feature
 * therefore goes through here rather than through `===`.
 *
 * This matters more than it looks. Identifying the base currency row is a code match now
 * — the responses' `isBase` is absent on Product Services and absent entirely on booking
 * services — so a comparison that gets the case wrong silently loses the coach's base row
 * or duplicates it.
 */

/**
 * Whether two currency codes name the same currency.
 *
 * @param a - a currency code, or nothing
 * @param b - a currency code, or nothing
 * @returns true only when both are present and name the same currency
 */
export function sameCurrency(
  a: string | null | undefined,
  b: string | null | undefined
): boolean {
  return !!a && !!b && a.toLowerCase() === b.toLowerCase();
}
